import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { Manifesto } from "@/components/site/Manifesto";
import { Freemium } from "@/components/site/Freemium";
import { Ribbon } from "@/components/site/Ribbon";
import { Products } from "@/components/site/Products";
import { WhatsInside } from "@/components/site/WhatsInside";
import { Footer } from "@/components/site/Footer";
import { PaymentReturn } from "@/components/site/PaymentReturn";
import { SupportWidget } from "@/components/site/SupportWidget";

export default function Landing() {
  return (
    <div className="relative bg-[#0A0A0C] text-white overflow-x-hidden">
      <Header />
      <main>
        <Hero />
        <Manifesto />
        <Freemium />
        <Ribbon />
        <Products />
        <WhatsInside />
      </main>
      <Footer />
      <PaymentReturn />
      <SupportWidget />
    </div>
  );
}
